import { Injectable } from '@angular/core';
const TOKEN_KEY = 'auth-token';
const REFRESHTOKEN_KEY = 'auth-refreshtoken';
const USER_KEY = 'auth-user';
const ACCESS_EXPIRE = 'access_expire';
const REFRESH_EXPIRE = 'refresh_expire';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {
  constructor() { }
  signOut(): void {
    sessionStorage.clear();
  }
  public saveToken(token: string): void {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.setItem(TOKEN_KEY, token);
    const user = this.getUser();
    if (user.id) {
      this.saveUser({ ...user, accessToken: token });
    }
  }
  public getToken(): string | null {
    return sessionStorage.getItem(TOKEN_KEY);
  }
  public saveRefreshToken(token: string): void {
    sessionStorage.removeItem(REFRESHTOKEN_KEY);
    sessionStorage.setItem(REFRESHTOKEN_KEY, token);
  }
  public getExpireToken(): string | null {
    return sessionStorage.getItem(ACCESS_EXPIRE);
  }
  public saveExpireToken(time: string): void {
    sessionStorage.removeItem(ACCESS_EXPIRE);
    sessionStorage.setItem(ACCESS_EXPIRE, time);
  }
  public getExpireRefreshToken(): string | null {
    return sessionStorage.getItem(REFRESH_EXPIRE);
  }
  public saveExpireRefreshToken(time: string): void {
    sessionStorage.removeItem(REFRESH_EXPIRE);
    sessionStorage.setItem(REFRESH_EXPIRE, time);
  }
  public getRefreshToken(): string | null {
    return sessionStorage.getItem(REFRESHTOKEN_KEY);
  }
  public saveUser(user: any): void {
    sessionStorage.removeItem(USER_KEY);
    sessionStorage.setItem(USER_KEY, JSON.stringify(user));
  }
  public getUser(): any {
    const user = sessionStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }
    return {};
  }
}
